<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="handleNext(2)"
      buttonName="退款"
      buttonType="warning"
      addShowPower="/refundmanage/tuikuan"
    >
      <select-organs
        v-model="formModel.tatSimpleId"
        :selectValue="formModel.tatSimpleId"
      ></select-organs>
      <el-form-item label="交易类型">
        <el-select v-model="formModel.operationType">
          <el-option
            v-for="item in operationTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          v-model="formModel.orderId"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model="formModel.phoneNumber"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input
          v-model="formModel.realName"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="操作时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatName"
        label="机构简称"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="电话号码"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderId"
        label="订单号"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="operationType"
        label="交易类型"
        min-width="100"
        :formatter="formatoperationTypes"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="150"
        :formatter="formatStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="操作时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="modifier"
        label="操作人"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <el-button type="text" @click="handleNext(1, scope.row)"
            >明细</el-button
          >
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";

import OrganService from "service/OrganService";
import ChannelService from "service/ChannelService";
import ChannelCashService from "service/ChannelCashService";
import OrganCashService from "service/OrganCashService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import SelectOrgans from "components/business/SelectOrgans";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "refundmanage",
  data() {
    return {
      formModel: {
        tatSimpleId: "",
        orderId: "",
        operationType: "",
        phoneNumber: "",
        realName: "",
        time: TimeRange.ThreeRange,
      },
      submitService: ChannelCashService.tatRefundList,
      page: {},
      tableData: [],
      operationTypes: [],
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        orderId: this.formModel.orderId,
        phoneNumber: this.formModel.phoneNumber,
        realName: this.formModel.realName,
        operationType: this.formModel.operationType,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.formModel.time.length) {
        params.createDateEnd = this.formModel.time[0];
        params.createDateStart = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getTypeNames("退款交易类型", (res) => {
      this.operationTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
    this.getList();
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    formatoperationTypes(row, column, cellValue, index) {
      let value = "--";
      this.operationTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatStatus(row, column, cellValue, index) {
      return cellValue == 1 ? "成功" : "失败";
    },
    handleNext(flag, item) {
      this.$router.push({
        name: "refundmanageinner",
        params: {
          info: JSON.stringify(item),
          flag: flag,
        },
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/RefundManage.vue